import screenLink from '../ScreenLink';

import linkRowTemplate from './linkRow.ejs';
import styles from './styles.less';

export default (props: any) => linkRowTemplate({
    ...props,
    screenLink,
    styles,
});
